import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles, markdown } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility'; 
import { EventManager } from '../../utilities/events';
import { ContextProvider} from '@lit/context';
import { memberContext } from '../../utilities/context';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { formatDateString } from '../../utilities/eventUtilities';
import {AllInMembersBase} from '../Utilities/AllInMembersBase';
import {deleteIcon} from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';

export class AllInMemberManager extends AllInSessionStorage(AllInMembersBase(LitElement)) {
    static properties = {
        config_membership: { type: Object, reflect:true},
        config_user: { type: Object, reflect:true},
        config_restUrl: { type: String, reflect:true},
        config_nonce: { type: String, reflect:true},
        config_hardlinks: { type: Object, reflect:true},
        dashboard:{type:String},
        membership: { type: Object},
        user: { type: Object, state:true },
        //create org state
        organisations: { type: Object },
        organisation: { type: Object},
        _hasFetchedOrgs: { type: Boolean, state:true },
        _fetchingOrgsComplete: { type: Boolean, state:true },
        panel: {type: String},
        view: {type: String},
        panels: {type: Object},
        name: { type: String },
        restUrl: { type: String },
        action: { type: String },
        nonce: { type: String },
        _fetchingMembershipComplete: {type: Boolean, state:true},
        _hasFetchedMembership: {type: Boolean, state:true},
        _evidenceNotificationsDismissed: {type: Array, state:true},
    }

    constructor() {
        super();
        this._fetchingMembershipComplete = false;
        this._hasFetchedMembership = false;
    }

    async connectedCallback() {
        super.connectedCallback();
        this.membership = this.config_membership;
        this.user = this.config_user;
        this.restUrl = this.config_restUrl;
        this.nonce = this.config_nonce;
        this.hardlinks = this.config_hardlinks;
        this.config_membership = null;
        this.config_user = null;
        this.config_restUrl = null;
        this.config_nonce = null;
        this.config_hardlinks = null;
        this.initiating = true;
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-membership-${this.name}-update`,this._handleUpdate);
        this.provisions = [];
        this.context = {
            name:this.name,
            membership:this.membership,
            user:this.user,
            dashboard:this.dashboard,
            panel:this.panel,
            view:this.view,
            panels:this.panels,
            restUrl:this.restUrl,
            action:this.action,
            nonce:this.nonce,
            provisions:this.provisions,    
            hardlinks:this.hardlinks
        };
        this._evidenceNotificationsDismissed = [];
        //get cookie for dismissed notifications
        let cookie = window.document.cookie.split(';').find(c => c.trim().startsWith(`evidenceNotificationsDismissed${this.membership?.hashed}=`));
        if(cookie){
            this._evidenceNotificationsDismissed = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
        }

        this._provider = new ContextProvider(this,{context:memberContext,initialValue:this.context});
        this.eventManager.initHistory({dashboard:this.dashboard??''});
        if(this.dashboard){
           // this[`_show${this.dashboard.charAt(0).toUpperCase() + this.dashboard.slice(1)}`]();
        }
        this.provisions = [];
        if(!this.provisions?.length){
             this._getMembershipProvisionsFromSessionStorage();
             if(!this.provisions?.length){
                 await this._fetchProvisions();
             }
        }
        cardLinks(this.shadowRoot);
        this.initiating = false;
    }

    async firstUpdated(){
        let nav = document.querySelector('allin-navigation');
        let breadcrumb = document.querySelector('allin-breadcrumb');

        await new Promise((resolve) => requestAnimationFrame(resolve));
        if(nav){
            await nav.updateComplete;
        }
        if(breadcrumb){
            await breadcrumb.updateComplete;
        }
        this._setSlotLinkClasses();
        this._fetchMembership();
        this._fetchOrganisations();
        this._loadNavigation();

    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    get _slottedLinkChildren() {
        const slot = this.shadowRoot.querySelector('slot[name="links"]');
        if(!slot) return [];
        return slot.assignedElements({flatten: true});
    }


    async updated(changedProperties){
        let changeHistory = true
        if(changedProperties.has('panel')&&this.panel){
            changeHistory = false;
        }
        //await new Promise((resolve) => requestAnimationFrame(resolve));
        if(changedProperties.has('dashboard')){
            if(this.dashboard===''){
                this.focus();
                this._emitReset();
            }
            else{
                this.panel='';
                this._emitDashboard(changeHistory);
            }
        }
        cardLinks(this.shadowRoot);
        //REMEMBER TO CHECK COMMENTING OUT THE LINE BELOW IN CASE ANY FUTURE ISSUES WITH SCROLLLING TO THE RIGHT SECTION OF THE PAGE
        this.scrollIntoView({behavior:'smooth',block:'start'});
    }

    render() {
        let main='';
        if(this.dashboard){
            if(this.dashboard=='profile'){
                main = html`
                   <allin-member-profile-form></allin-member-profile-form>
                    `;
            }
            else if(this.dashboard=='supporting_documents'){
                main = html`
                <allin-member-document-form></allin-member-document-form>`;
            }
            else if(this.dashboard=='share'){
                main = html`
                <h2>${msg(str`Share my profile`)}</h2>
                <slot name="share-profile-description"></slot>
                <allin-member-share-profile></allin-member-share-profile>
                <slot name="share-profile-banner"></slot>
                `;
            }
        }
        else{
            let invites='';
            let groupInvites = '';
            let notifications = '';
            let notificationsArray = [];
            let hasFetchedMembershipSpinner = '';
            let slot = html`<slot name="membership-welcome-text" @slotchange=${this._processSlot}></slot>`;
            if(!this._hasFetchedMembership) {
                    hasFetchedMembershipSpinner = html`
                    <div class="has-fetched-orgs-spinner"><p class="small">${msg(str`Checking for updates`)}</p></div>
                `;
            }
            let evidenceRequired = this._getEvidenceRequiredProvisions();
            /* if(!this.membership.isIdentityVerified&&evidenceRequired&&evidenceRequired.length > 0 && this._evidenceNotificationsDismissed.length < evidenceRequired.length){
                let link = html`<a href="javascript:void(0)" @click=${(e)=>{e.preventDefault();this.dashboard='supporting_documents';}}>${msg('Verify your ID')}</a>`;
                notificationsArray.push(html`
                        <li>
                            <div><p>${msg(`You need to verify your identity to submit evidence.`)}</p>${link}</div>
                        </li>
                `);
            } */
            if(evidenceRequired&&evidenceRequired.length > 0){
                evidenceRequired.forEach((provision)=>{
                    if(this._evidenceNotificationsDismissed.includes(provision.standard.id)) return;
                    let link = html`<a href="javascript:void(0)" @click=${(e)=>{e.preventDefault();this.dashboard='supporting_documents';}}>${provision.details.evidenceRequiredButtonText?provision.details.evidenceRequiredButtonText:msg(str`Add supporting document`)}</a>`;
                    let message = provision.details.evidenceRequiredMessage;
                    if(!message){
                        message = msg(str`Some organisation require evidence for ${provision.details.name}.`);
                    }
                    if(provision.evidence.length > 0){
                        let latestEvidence = provision.evidence.sort((a,b)=>new Date(b.validUntil) - new Date(a.validUntil))[0];
                        if(latestEvidence.status=='RequestInfo'){
                            if(latestEvidence.note){
                                message = latestEvidence.note;
                            }
                        }
                    }
                    notificationsArray.push(html`
                        <li>
                            <div><p>${message}</p>${link}<button class="dismiss_button" @click=${()=>{this._dismissEvidenceNotification(provision.standard.id)}}><span aria-hidden="true">${deleteIcon}</span><span class="screen-reader-text">${msg(str`Dismiss notification for ${provision.details.name} evidence`)}</span></button></div>
                        </li>
                    `);
                });
            }   
            if(notificationsArray.length > 0){
                notifications = html`
                    <div class="message">
                        <h4>You have ${notificationsArray.length} notification${notificationsArray.length > 1 ? 's' : ''}</h4>
                        <ul>${notificationsArray}</ul>
                    </div>
                `;
            }
            let supportingDocuments = this._getEvidenceRequiredProvisions(true);
            let supportingDocumentsStr = '';
            if(supportingDocuments&&supportingDocuments.length > 0){
                let docsArray = supportingDocuments.map((provision)=>{
                    let status = msg(str`Not submitted yet`);
                    if(provision.evidence.length > 0){
                        let sortedEvidence = provision.evidence.sort((a,b)=>new Date(b.validUntil) - new Date(a.validUntil));
                        let latestEvidence = sortedEvidence[0];
                        if(latestEvidence.status=='Approved'){
                            status = msg(str`Valid`);
                            if(latestEvidence.validUntil){
                                if(new Date(latestEvidence.validUntil) < new Date()){
                                    status = msg(str`Expired on ${formatDateString(latestEvidence.validUntil, false, false)}`);
                                }
                                else{
                                    status = msg(str`Valid until ${formatDateString(latestEvidence.validUntil, false, false)}`);
                                }
                            }
                        }
                        else if(latestEvidence.status=='Rejected'){
                            status = msg(str`Rejected`);
                        }
                        else if(latestEvidence.status=='AwaitingResponse'){
                            status = msg(str`Submitted, awaiting review`);
                        }
                        else if(latestEvidence.status=='RequestInfo'){ 
                            status = msg(str`More information required`);
                        }
                    }
                    return html`<dd>${provision.details.name} <span class="bg_white">${status}</span></dd>`;
                });
                supportingDocumentsStr = html`
                    <dt>Supporting document</dt>
                    ${docsArray}
                `;
            }
            let inProgress = '';
            if(this.membership.hasOwnProperty('inProgress') && this.membership.inProgress >= 0 && this.membership.inProgress < 4){
                inProgress = html`
                    <div class="message">
                        <h4>${msg(str`You have a form in progress`)}</h4>
                        <p>${msg(str`It looks like you have a form in progress. Please complete it to ensure your membership is up to date.`)}</p>
                        <a class="button" href="/dashboard/create-membership?in_progress=${this.membership.inProgress}&&ppage=${this.membership.inProgress}">${msg(str`Continue form`)}</a>
                    </div>
                `;
            }
            main = html` 
                ${inProgress}
                <h2><allin-greeting username=${this.user.firstName} loggedin></allin-greeting></h2>
                ${slot}
                ${notifications}
                <div class="bg bg_grey profile-card">
                    ${hasFetchedMembershipSpinner}
                    <dl>
                        <dt>${msg(str`My name`)}</dt>
                        <dd>${this.user.firstName} ${this.user.lastName}</dd>
                        <dt>${msg(str`My member number`)}</dt>
                        <dd>${this.membership.allInMemberNumber}</dd>
                        ${supportingDocumentsStr}
                    </dl>
                </div>
                <div class="links_wrapper ${this.membership.isIdentityVerified ? 'onboarded' : ''}">
                    <slot name="links">
                    </slot>
                </div>
            `
        }
        return html`${main}`;
    }


    _emitReset(){
        this._setDocumentTitle('Membership dashboard');
        this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,revert:true});
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:'reset',currentPage:'/dashboard'});
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,null);
        this.eventManager.addHistory('/dashboard',{currentOrg:'',dashboard:''});
        this.organisation = null;
        this.context = {...this.context,dashboard:this.dashboard};
        this._provider?.setValue(this.context);
    }

    _setDocumentTitle(title){
        document.title = `${title} - All In`;
    }

    async _emitDashboard(changeHistory,reset=false){
        let path = 'profile';
        let name = msg(str`Manage my member profile`);
        this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,revert:true});
        if(this.dashboard=='supporting_documents'){
            path = 'supporting_documents';
            name = msg(str`Submit my supporting documents`);
        }
        else if(this.dashboard=='share'){
            path = 'share';
            name = msg(str`Share my profile`);
        }  
        let nav = document.querySelector('allin-navigation');
        let breadcrumb = document.querySelector('allin-breadcrumb');
        if(breadcrumb){
            await breadcrumb.updateComplete;
        }
        let crumb = {title:msg(str`Membership dashboard`),dashboard:{url:`/dashboard/${path}`,title:name}};
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        await new Promise((resolve) => requestAnimationFrame(resolve));
        if(nav){
            await nav.updateComplete;
        }
        this._setDocumentTitle(name);
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getNav(),currentPage:'/dashboard/'+path});
    
        if(changeHistory){
            this.eventManager.addHistory('/dashboard/'+this.dashboard,{dashboard:this.dashboard});
        }
        this.context = {...this.context,dashboard:this.dashboard,panel:this.panel,view:this.view};
        this._provider.setValue(this.context);
    }

    _loadNavigation(){
        let nav = this._getNav();
        if(document.readyState === "loading"){
            document.addEventListener("DOMContentLoaded",()=>{
                this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:nav, initial:true,currentPage:`/dashboard`});
            })
        }
        else{
            this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:nav, initial:true,currentPage:`/dashboard`});
        }
    }

    _showDashboard(e=false){
        if(e){
            e.preventDefault();
        }
        this.dashboard = '';
    }

    _showSupportingDocuments(e=false){
        if(e){
            e.preventDefault();
        }
        this.dashboard = 'supporting_documents';
        this._emitDashboard(true);
    }

    
    _getNav(){
        let nav =
            [
                {
                    'url': '#',
                    'title' : msg(str`Dashboard`),
                    'id':'dashboard',
                    'callback': (e)=>{e.preventDefault(); this._showDashboard()}
                },
                { 
                    'url': '#',
                    'title' : msg(str`Manage my member profile`),
                    'id' : 'dashboardprofile',
                    'callback': (e)=>{e.preventDefault(); this.dashboard='profile'}
                },
            ];
        if(this.dashboard=='profile'||this.dashboard=='supporting_documents'){
            nav.push({
                indent:true,
                'url' : '#',
                'title' : msg(str`Submit my supporting documents`),
                'id' : 'dashboardsupporting_documents',
                'callback': (e)=>{e.preventDefault(); this.dashboard='supporting_documents'}
            });
        }
        /*nav.push(
            {
                'url' : '#',
                'title' : msg(str`Share my profile`),
                'id' : 'dashboardshare',
                'callback': (e)=>{
                    e.preventDefault();
                    this.dashboard='share'
                }
            },
        );*/
        nav.push(
            {
                'url' : '/my-account-settings',
                'title' : msg(str`Manage my account`),
                'id' : 'dashboardsettings',
                'callback': ()=>{this.dashboard='settings'}
            }
        );
       /*  nav.push(
            {
                'url' : 'https://allin.zendesk.com',
                'title' : msg(str`Account Help Centre`),
            }
        );    */
        /**Request to remove this, but leaving logic in case it's needed in the future */
        /* if(this._hasFetchedOrgs) {
            // Organisation link
            const hasOrganisation =
                Array.isArray(this.organisations) &&
                this.organisations.length > 0;

            if (hasOrganisation) {
                nav.push({
                    url: '/organisation-dashboard',
                    title: msg(str`Organisation Dashboard`),
                    id: 'organisation-dashboard-link'
                });
            } else {
                nav.push({
                    url: '/organisation-dashboard/create-organisation/',
                    title: msg(str`Create an organisation`),
                    id: 'create-organisation'
                });
            }
        } */

        return [nav];
    }

    _fetchOrganisations(){
        if(this._fetchingOrgsComplete) return;
        this._fetchingOrgsComplete = true;

        let url = `${this.restUrl}?action=get_user_organisations&nonce=${this.nonce}`;

        fetch(url, {
            headers: {
                'AllIn-Nonce': this.nonce,
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            this.organisations = data.sort((a,b)=>a.name.localeCompare(b.name));
            this._hasFetchedOrgs = true;

            //Reload nav after fetching org data
            this._loadNavigation();
        })
        .catch(error => {
            console.error('Error fetching organisations:', error);
            this._hasFetchedOrgs = true;
        });
    }

    _handleUpdate(e){

        if(e.detail.provisions!=null){
            let provisions= JSON.parse(e.detail.provisions);
            this.context = {...this.context,provisions:provisions};
            this._provider.setValue(this.context);
        }
        if(e.detail.panel!=null){
            this.panel = e.detail.panel;
            this.context = {...this.context,panel:this.panel};
            this._provider.setValue(this.context);
        }
        if(e.detail.dashboard!=null){
            this.dashboard = e.detail.dashboard;
            this.context = {...this.context,dashboard:this.dashboard};
            if(e.detail.panel){
                this.panel = e.detail.panel;
                if(e.detail.view){
                    this.view = e.detail.view;
                    this.context = {...this.context,panel:e.detail.panel,view:e.detail.view};
                }
                else{
                    this.context = {...this.context,panel:e.detail.panel};
                }
            }
            this._provider.setValue(this.context);
        }
        if(e.detail.view!=null){
            this.view = e.detail.view;
            this.context = {...this.context,view:this.view};
            this._provider.setValue(this.context);
        }
        if(e.detail.membership!=null){
            this.membership = e.detail.membership;
            this.context = {...this.context,membership:this.membership};
            this._provider.setValue(this.context);
        }

    }
   

    _setSlotLinkClasses(){
        //Commented for now. 
        /* let slots = this._slottedLinkChildren;
        if(!slots||!slots.length) return;
        slots = slots[0];
        let child = slots.firstElementChild;
        if(!child) return;
        child.classList.remove('onboarded');
        let onboarded = this.membership.isIdentityVerified?'onboarded':'';
        if(onboarded){
            child.classList.add(onboarded);
        } */
    }
   
    _fetchMembership(){
         // Fetch membership from the server
        if(this._fetchingMembershipComplete) return;
        this._fetchingMembershipComplete = true;
        let url = `${this.restUrl}?action=get_user_membership&nonce=${this.nonce}`;
        fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })
            //.then(response => response.json())
            .then(response => {
                if (response.status === 403) {
                    handle403s();
                    return Promise.reject(new Error(`Server returned ${response.status}: Session expired`));
                }

                if (!response.ok) {
                    throw new Error(`Server returned ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                
                this.membership = data.membership;
                this.context = {...this.context, membership:this.membership};
                this._provider.setValue(this.context);
                this._hasFetchedMembership = true;

                
            })
            .catch(error => {
                console.error('Error fetching membership:', error);
                this._hasFetchedMembership = true;
            });
    }

    async _fetchProvisions(){
        let url = `${this.restUrl}?action=get_all_member_provisions&nonce=${this.nonce}`;
        try{
            const response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            this.provisions = data.provisions;
            this._loading = false;
            this._setMembershipProvisionsToSessionStorage();
            this.context = {...this.context,provisions:this.provisions};
            this._provider.setValue(this.context);
        }
        catch(error){
            console.error('Error:', error);
        }
    }

    _dismissEvidenceNotification(provisionId){
        if(!this._evidenceNotificationsDismissed.includes(provisionId)){
            this._evidenceNotificationsDismissed = [...this._evidenceNotificationsDismissed, provisionId];
            //set cookie for a year            
            let date = new Date();
            date.setTime(date.getTime() + (365*24*60*60*1000));
            document.cookie = `evidenceNotificationsDismissed${this.membership?.hashed}=${encodeURIComponent(JSON.stringify(this._evidenceNotificationsDismissed))}; expires=${date.toUTCString()}; path=/`;
        }
    }

    

    static styles = [
        ...super.styles,
        accessibility,
        formStyles,
        markdown,
        css`
        allin-greeting{
            --allin-font-size: 1.5rem;
            --allin-font-weight: 700;
        }
        h2:has(> allin-greeting):not(:has(> :not(allin-greeting))) {
            margin: 0;
        }
        h3{
            margin-top:0;
            color:var(--allin-heading-color,#000);
        }

        h4{
            margin:0.5rem 0;
            font-size:1rem;
        }
        
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg_grey{
            background-color:var(--color-grey,#e8e8e8);
        }
        .bg.profile-card {
            position: relative;
        }
        .has-fetched-orgs-spinner {
            position: absolute;
            top: 0.5rem;
            right: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        .has-fetched-orgs-spinner p {
            margin:0;
        }
        .has-fetched-orgs-spinner::after {
            content:'';
            display:block;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
            z-index: 100;
            background-image: url(/wp-content/themes/ace/assets/wheel.svg);
            background-size: cover;
        }
        @keyframes spin {
            from {transform: rotate(0deg);}
            to {transform: rotate(360deg);}
        }
        .small{
            font-size:0.875rem;
        }

        .message{
            margin-bottom:0.5rem;
        }
        .semibold{
            font-weight:600;
        }
      
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            gap:0.5rem;
            margin-bottom:1.5rem;
        }

        ul li img{
            object-fit:contain;
        }
        ul li a, .support-profile a{
            display:block;
            padding:0.5rem;
            color:var(--allin-button-color,#472961);
            background-color:var(--allin-button-bg-color,#fff);
            text-decoration:none;
            border:1px solid var(--allin-button-color,#472961);
            border-radius:var(--allin-border-radius,0.25rem);
            transition:background-color var(--transition) ease;
            width:fit-content;
            font-weight:700;
        }
        ul li a:hover, .support-profile a:hover{
            background-color:var(--allin-button-hover-bg-color,#472961);
            color:var(--allin-button-hover-color,#fff);
        }

        .content{
            display:grid;
            grid-template-columns:auto 1fr;
            gap:0.5rem;
        }
        .content .message{
            justify-self:end;
        }
        .content .semibold, .content a{
            grid-column:1/-1;
            word-break: break-word;
        }
        .content a{
            height:fit-content;
            align-self:end;
        }
        .button{
            margin-top:1rem;
            width:100%;
            display: block;
            text-align: center;
            box-sizing:border-box;
        }

        ul li h5{
            margin:0 0 1rem;
        }
        @media (min-width: 600px){
            ul li{
                grid-template-columns:200px 1fr 1.5rem;
                gap:2rem
            }
            ul li h4{
                margin-top:0;
            }
           
        }
        .grid{
            display:grid;
            gap:1rem;
        }
        .grid allin-greeting{
            --allin-margin:0 0 0.5rem 0;
        }

        :not(:defined) {
	        display: none;
        }

        .notices span{
            background-color: var(--allin-button-bg-color,#fff);
            color:var(--allin-button-color,#472961);
            border: 1px solid var(--allin-button-color,#472961);
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content: center;
            padding:0 0.75rem;
        }
       
       

        .message ul{
            list-style:disc;
            padding-left:1rem;
            margin:0;
        }

        .message ul li{
            display:list-item;
        }

        .message ul li div{
            grid-template-columns: 1fr 15ch;
            display:grid;
            gap:1rem;
            &:has(> button.dismiss_button){
                position:relative;
            }
            button.dismiss_button{
                position:absolute;
                top:-0.25rem;
                right:-0.5rem;
                padding:0;
                background-color:transparent;
            }
        }
        .message ul li p{
            margin:0;
        }
        .message ul li a{
            color: var(--allin-button-color,#472961);
            text-decoration: underline;
            padding:0;
            border:none;
            background:transparent;
        }

        p.org-flavour-text{
            margin-bottom: 2rem;
        }
        
        .invites ul li{
            background-color: var(--color-grey);
            padding: 2rem;
            display:block;
            strong{
                margin-bottom:1rem;
                display:block;
            }
            button.loading{
                opacity:0.6;
                pointer-events:none;
            }
        }
        .links_wrapper{
            margin-top:2rem;
        }
       

        `
        ];


}